import { Box, Divider, Typography } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import DiscordIcon from "../../../assets/images/icons/DiscordIcon";
import MailIcon from "../../../assets/images/icons/MailIcon";
import BriaButton from "../../../components/common/BriaButton/BriaButton";
import LinkConstants from "../../../constants/LinkConstants";
import DashboardWidget from "../Widget/DashboardWidget";
import styles from "./ContactWidget.module.scss";

type Props = {
	className?: string;
};

const ContactWidget = ({ className }: Props) => {
	const { t } = useTranslation("dashboard", { keyPrefix: "contact" });

	return (
		<DashboardWidget className={clsx(styles.widget, className)} title={t("title")}>
			<Divider className={styles.divider} />
			<Box className={styles.options}>
				<Box className={styles.row}>
					<Typography className={styles.text}>{t("discord.text")}</Typography>
					<BriaButton
						className={styles.button}
						buttonType="secondarySmall"
						startIcon={<DiscordIcon />}
						onClick={() => window.open(LinkConstants.DISCORD_COMMUNITY)}
					>
						{t("discord.button")}
					</BriaButton>
				</Box>
				<Box className={styles.row}>
					<Typography className={styles.text}>{t("support.text")}</Typography>
					<BriaButton
						className={styles.button}
						buttonType="secondarySmall"
						startIcon={<MailIcon />}
						onClick={() => window.open(LinkConstants.CONTACT_US_FORM_LINK)}
					>
						{t("support.button")}
					</BriaButton>
				</Box>
			</Box>
		</DashboardWidget>
	);
};

export default observer(ContactWidget);
